module.exports = __webpack_public_path__ + "media/images/users_voice05-25e9e972643b59d5a895ca01984aaf41.jpg";